import {isEmpty, get as _get, sortBy, escape} from 'lodash';
import initialstate from '../initialstate';
import {currentResource, labels} from '../../util/utils';
import Utility from '../../util/utilityfunctions';
import normalizerComponentsTeam from './normalizerComponentsTeam';
import {HttpStatusCodes, MSGraphURL, GALinkStatus} from '../../util/uiconstants';
import updateGATeamsLinkRequest from './updateGATeamsLinkRequest';
import updateGAScopesLinkRequest from './updateGAScopesLinkRequest';
import {
	GET_GA_TEAMS,
	GET_MS_PHOTO,
	SET_PHOTO,
	SET_PHOTO_HTML,
	ADD_GA_TEAM,
	DELETE_GA_TEAM,
	RESET_GA_TEAMS,
	GET_LINK_REQUEST_GA_TEAMS,
	CHANGE_GA_TEAM_LINK_REQUEST,
	CHANGE_GA_SCOPE_LINK_REQUEST,
	SET_TEAM_LINK_STATUS_LOADING
} from '../../actions/actiontypes';
import getSelectedTeamsIds from './getSelectedTeamsIds';
import setTeamLinkStatusLoading from './setTeamLinkStatusLoading';

const normalizeTeam = (t) => ({
	id: t.gaComponentID.toString(),
	pid: t.parentComponentID ? t.parentComponentID.toString() : null,
	linkStatusIcon: Utility.getGALinkStatusIcon(t.gaLinkStatusID),
	scopeLabel: labels.scope,
	shortCustomName: t.shortName.replaceAll('<', '&lt;').replaceAll('>', '&gt;'),
	scopeCustomName: GALinkStatus.ComponentReferenceOnly === t.gaLinkStatusID ? labels.notApplicable : t.gaScopeName,
	pocCustomText: Utility.hasPOC(t.gaLinkStatusID) ? t.pocText : '',
	pocCustomEmail: Utility.hasPOC(t.gaLinkStatusID) ? t.pocEmail : '',
	noPOC: Utility.hasPOC(t.gaLinkStatusID) ? '' : currentResource.gaLinkStatusObj[t.gaLinkStatusID],
	...t
});

function addCustomFields(t, hasPic) {
	return {
		eyEmail: Utility.getImgHTML(t.pocEmail, hasPic, t.pocText, t.gaLinkStatusID),
		...t
	};
}

export function gaTeamsReducer(state = initialstate.gaTeams, action) {
	switch (action.type) {
		case GET_GA_TEAMS: {
			if (!isEmpty(action.response)) {
				let listOfTeams = action.response.map(normalizeTeam);
				listOfTeams = sortBy(listOfTeams, [
					function(o) {
						return o.shortName?.toLowerCase();
					}
				]);
				return {
					...state,
					components: listOfTeams
				};
			}

			return {
				...state,
				components: []
			};
		}
		case GET_MS_PHOTO: {
			const wasFound = action.responseObj?.status === HttpStatusCodes.Ok;
			let statePhotos = [];
			if (!isEmpty(state.photos)) {
				statePhotos = [...state.photos];
			}
			if (wasFound) {
				statePhotos.push({email: action.userEmail, blob: action.response});
			}

			return {
				...state,
				photos: statePhotos
			};
		}
		case SET_PHOTO: {
			return {
				...state,
				components: [...state.components],
				photos: [...action.payload]
			};
		}
		case SET_PHOTO_HTML: {
			let teams = [...state.components];
			teams = teams.map((t) => {
				const hasPhoto = state.photos.find((p) => p.email === t.pocEmail)?.base64 || false;
				// console.log(currentResource.gaLinkStatusObj[t.gaLinkStatusID]);
				return addCustomFields(t, hasPhoto);
			});

			//teams = sortBy(teams, ['shortName']);

			return {
				...state,
				components: teams
			};
		}
		case ADD_GA_TEAM: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Created) {
				let createdTeam = normalizeTeam(_get(action, 'response'));
				const hasPhoto = state.photos.find((p) => p.email === createdTeam.pocEmail)?.base64 || false;
				createdTeam = addCustomFields(createdTeam, hasPhoto);
				return {
					...state,
					components: [...state.components, createdTeam]
				};
			}
			return state;
		}
		case DELETE_GA_TEAM: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.NoContent) {
				const removedComponentId = _get(action, 'payload.componentId', null);
				if (removedComponentId !== null) {
					return state;
				}
			}
			return state;
		}
		case RESET_GA_TEAMS: {
			return initialstate.gaTeams;
		}
		case GET_LINK_REQUEST_GA_TEAMS: {
			if (!isEmpty(action.response)) {
				let listOfT = action.response.map(normalizeTeam);
				listOfT = sortBy(listOfT, [
					function(o) {
						return o.shortName?.toLowerCase();
					}
				]);
				listOfT = normalizerComponentsTeam(listOfT);
				return {
					...state,
					linkRequestTeam: listOfT
				};
			}
			return {
				...state,
				linkRequestTeam: []
			};
		}
		case CHANGE_GA_TEAM_LINK_REQUEST: {
			const teamId = _get(action, 'teamId', null);
			if (teamId) {
				return {
					...state,
					linkRequestTeam: updateGATeamsLinkRequest(state.linkRequestTeam, teamId)
				};
			}
			return {
				...state,
				linkRequestTeam
			};
		}
		case CHANGE_GA_SCOPE_LINK_REQUEST: {
			const scopeId = _get(action, 'scopeId', null);
			const checked = _get(action, 'checked', null);

			if (scopeId) {
				const afterChange = updateGAScopesLinkRequest(state.linkRequestTeam, scopeId, checked);
				return {...state, linkRequestTeam: afterChange};
			}

			return {
				...state,
				linkRequestTeam
			};
		}
		case SET_TEAM_LINK_STATUS_LOADING: {
			const ids = getSelectedTeamsIds(state.linkRequestTeam);
			return {
				...state,
				components: setTeamLinkStatusLoading(state.components, ids, action?.payload),
				linkRequestTeam: setTeamLinkStatusLoading(state.linkRequestTeam, ids, action?.payload, true)
			};
		}
		default:
			return state;
	}
}
